import type { PurchaseEvent } from '../types/liveActivity'

export const purchaseEvents: PurchaseEvent[] = [
  { id: 'p1', name: 'Ashley T.', city: 'Nashville, TN', minutesAgo: 2 },
  { id: 'p2', name: 'Megan R.', city: 'Portland, OR', minutesAgo: 4 },
  { id: 'p3', name: 'Danielle M.', city: 'Savannah, GA', minutesAgo: 6 },
  { id: 'p4', name: 'Sarah P.', city: 'Austin, TX', minutesAgo: 9 },
  { id: 'p5', name: 'Nicole H.', city: 'Columbus, OH', minutesAgo: 11 },
  { id: 'p6', name: 'Erin V.', city: 'Salt Lake City, UT', minutesAgo: 13 },
  { id: 'p7', name: 'Jessica W.', city: 'Chicago, IL', minutesAgo: 16 },
  { id: 'p8', name: 'Brittany S.', city: 'Raleigh, NC', minutesAgo: 18 },
  { id: 'p9', name: 'Kaitlyn D.', city: 'Boise, ID', minutesAgo: 21 },
  { id: 'p10', name: 'Amanda K.', city: 'Orlando, FL', minutesAgo: 24 }
]

export const LIVE_ACTIVITY = {
  /** Seconds each purchase notification stays on screen. */
  visibleMs: 6000,
  /** Gap between notifications. */
  hiddenMs: 5000,
  /** Delay before the first notification appears. */
  firstDelayMs: 4000,
  viewersBase: 214,
  viewersJitter: 9,
  viewersTickMs: 4000
} as const
